import { render, staticRenderFns } from "./TextStyles.vue?vue&type=template&id=824ba3b6&"
import script from "./TextStyles.vue?vue&type=script&lang=js&"
export * from "./TextStyles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports